/*
 * @Date         : 2021-09-13 09:52:26
 * @LastEditors  : zhangxu
 * @LastEditTime : 2021-11-20 14:00:36
 * @FilePath     : /daodao-biz-front/src/store/growthCenter.ts
 * @Description  : 成长中心store
 */
import { GrowthCenter } from '@/interface/growthCenter'
interface State {
  swichViewBtnDisabled: boolean
  allCustomSettingList: {}
  isSimpleList: boolean
  // 回公海用户列表
  selectedClientList: string[]
  listEditItem: ListEditItem
  // 指派相关参数
  appointClientCount: number
  selectAllDataFlag: boolean
  appointClientRule: GrowthCenter.AppointClientRule
  appointClientList: string[]
  appointClientExcludeList: string[]
  nameDesensitizeStatus: boolean
  growAiCloseHanlder: Function
}
interface ListEditItem {
  clientId: string
  name: string
  recordId: string
  mode: number
  type?: 1 | 2 | 3 // 1:用户分级 2:跟进记录 3:微信号
}

export default {
  namespaced: true,
  state: {
    isSimpleList: false,
    selectedClientList: [], // 选中的档案列表
    listEditItem: { clientId: '0' }, //  列表页面是否处于编辑态
    appointClientCount: 0,
    selectAllDataFlag: false,
    appointClientRule: {},
    appointClientList: [],
    appointClientExcludeList: [],
    allCustomSettingList: {},
    nameDesensitizeStatus: !!localStorage.getItem('nameDesensitize'),
    swichViewBtnDisabled: true, // Topper栏切换视图按钮禁用
    growAiCloseHanlder: () => {},
  },
  getters: {
    // 获取指派list
    getAppointClientData: (state: State) => ({
      appointClientCount: state.appointClientCount,
      selectAllDataFlag: state.selectAllDataFlag,
      appointClientRule: state.appointClientRule,
      appointClientList: state.appointClientList,
      appointClientExcludeList: state.appointClientExcludeList,
    }),
  },
  mutations: {
    setGrowAiCloseHanlder(state: State, payload: Function) {
      state.growAiCloseHanlder = payload
    },
    setAppointClientCount(state: State, payload: number) {
      state.appointClientCount = payload
    },
    setSelectAllDataFlag(state: State, payload: boolean) {
      state.selectAllDataFlag = payload
    },
    setAppointClientRule(state: State, payload: GrowthCenter.AppointClientRule) {
      state.appointClientRule = { ...payload }
    },
    setAppointClientList(state: State, payload: string[]) {
      state.appointClientList = [...payload]
    },
    setAppointClientExcludeList(state: State, payload: string[]) {
      state.appointClientExcludeList = [...payload]
    },
    setAllCustomSettingList(state: State, payload: string[]) {
      state.allCustomSettingList = { ...payload }
    },
    clearAppointClientData(state: State) {
      state.selectAllDataFlag = false
      state.appointClientRule = {
        followTeacherList: [] as string[],
        activityList: [] as string[],
      }
      state.appointClientList = []
      state.appointClientList = []
    },
    switchIsSimpleList(state: State) {
      state.isSimpleList = !state.isSimpleList
    },
    setSelectedClientList(state: State, payload: string[]) {
      state.selectedClientList = [...(payload || [])]
    },
    setListEditItem(state: State, payload: ListEditItem) {
      state.listEditItem = payload
    },
    clearListEditItem(state: State) {
      state.listEditItem = {
        clientId: '0',
        name: '',
        recordId: '',
        mode: 1,
      }
    },
    setNameDesensitizeStatus(state: State, nameDesensitizeStatus: boolean) {
      state.nameDesensitizeStatus = nameDesensitizeStatus
    },
    setSwichViewBtnDisabled(state: State, payload: boolean) {
      state.swichViewBtnDisabled = payload
    },
  },
}
